import { LoginUserModel } from './../../../models/login-user-model';
import { Component, OnInit , VERSION } from "@angular/core";
import { Router } from "@angular/router";
const swal = require('sweetalert');
import { Location, LocationStrategy } from '@angular/common';
import { UntypedFormControl, FormsModule, Validators, FormControl } from "@angular/forms";
import { LoginService } from "../../../services/login/login.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { isUndefined } from "util";
import { RegisterUserService } from './../../../services/registerUser/register-user.service';
import { environment } from '../../../../environments/environment';
import {isNumeric} from "isNumeric";
import { TransactionService } from '../../../services/transaction/transaction.service';
const _clone = (d) => JSON.parse(JSON.stringify(d));

import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
//import { Component, VERSION } from "@angular/core";
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import {   ViewChild, ElementRef } from '@angular/core';
@Component({
  selector: "ms-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  host: {
    "[@fadeInAnimation]": "true"
  }
})
export class LoginComponent implements OnInit {
  SessionId:any;
  IsLocationAllow:boolean=false;
  GeoLocation:any;
  deviceInfo : any;
  devicetype:any;
  ipaddressrequired:boolean=false;
  AccountLockDate:any;
  Merchantstatus:any;
  resellerid:any;
  singupurl:any;
  image:boolean=false;
  paygimage:boolean=true;
  whitelableName:any;
  paygname:boolean=true;
  resellername:boolean=false;
  content;
  isView: boolean = false;
  isNoView: boolean = true;
  @ViewChild('alert', { static: true }) alert: ElementRef;


  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
     
  } 
  itl:boolean=false;
  ien:boolean=false;
  ihi:boolean=false;
  indiafields:boolean=true;
  Usfields:boolean=false;
  Url:any;
  CurrentIp:any;
  usernameerror:boolean=false;
  lockdates:any;
  AccountBlocked:boolean=false;
  username:any;
  paygsetup=0;
  payoutvalue=0;
  rows=[];
  imagepath:any;
  isloginSuccess: any = true;
  ipAddressValidationMsg:any;
  isloginfailed: boolean = false;
  isIpAddressVerified: boolean = false;
  isPasswordExpired: boolean = false;
  isValidMerchant: boolean = true;
  isMerchantNotActive: boolean = false;
  isAccountApproved: boolean = false;
  isAccountRejected: boolean = false;
  isAccountVerificationPending: boolean = false;
  isAccountOnHold: boolean = false;
  isAccountCancled: boolean = false;
  isAccountDeclined: boolean = false;
  isEmailConfirmationPending: boolean = false;
  hidebutton: boolean = true;
  email = new FormControl("", [Validators.required]);
  password = new FormControl("", [Validators.required]);
  resellerUrl="";
  nooftimeserrormessage:boolean=false;
  times=0;
  nooftimes:number;
  showPassword: boolean = false;
  constructor(
    private deviceService: DeviceDetectorService,
    private router: Router,
    private service: LoginService,
    private commonfunction: CommonFunctionService,
    private registerUserService: RegisterUserService,
    private services: TransactionService,
    private location: Location, private locationStrategy: LocationStrategy,
  ) { 
    // this.Url = this.router.url.includes('us/en');
    if (window !== window.top) {
      window.top.location = window.location;
  }
    if(this.router.url.includes('us/en'))
    {
      this.Usfields=true;
      this.indiafields=false;
      this.itl=false;
      this.ien=false;
      this.ihi=false;
      // this.singupurl="/us/en/registration/new";
    }
    else if (this.router.url.includes('in/te'))
    {
      this.Usfields=false;
      this.indiafields=false;
      this.itl=true;
      this.ien=false;
      this.ihi=false;
    }
    else if (this.router.url.includes('in/en'))
    {
      this.Usfields=false;
      this.indiafields=false;
      this.ien=true;
      this.itl=false;
      this.ihi=false;
    }
    else if (this.router.url.includes('in/hi'))
    {
      this.Usfields=false;
      this.indiafields=false;
      this.ihi=true;
      this.itl=false;
      this.ien=false;
    }
    else{
      this.Usfields=false;
      this.indiafields=true;
      this.itl=false;
      this.ien=false;
      this.ihi=false;
      // this.singupurl="/registration/new";
    }
    
    this.epicFunction();
  }

  ngOnInit() {
    this.getUserLocation();
    localStorage.removeItem('VirtualPOSToken');
    // this.imagepath=environment.ImagePathUrl;
    localStorage.removeItem('logodetails');
    localStorage.removeItem('logoimagepath');
    localStorage.removeItem('Merchantinfoes');
    localStorage.removeItem('Status');
    localStorage.removeItem("WhitelabelContent");
    localStorage.removeItem("ResellerEmail");
    localStorage.removeItem("ResellerPhoneNumber");
    localStorage.removeItem("ResellerName");
    var url=location.href;
    if(environment.production==true)
    {
      var Oururl = url.substring(
        url.lastIndexOf("https://") + 8, 
        url.lastIndexOf("/merchant")
        );   
    }
    else{
      var Oururl = url.substring(
        url.lastIndexOf("uat.") + 4, 
        url.lastIndexOf("/merchant")
        );
    }
    localStorage.setItem("ResellerUrl", Oururl);
    this.service.getresellerdatabasedonurl(Oururl).subscribe(res => {
      if(res!=null){
        this.resellerid=res.ResellerId;
        this.whitelableName=res.ResellerName;
        this.resellerUrl = Oururl;
        localStorage.setItem("Whitelabelurl",res.Url);
        localStorage.setItem("ResellerEmail", res.BusinessEmail);
        localStorage.setItem("ResellerPhoneNumber", res.ContactNumber);
        localStorage.setItem("ResellerName", res.ResellerName);
        this.service.getresellerlogo(this.resellerid).subscribe(result => {
          if(result!=null){
          if(result.Content!=null && res.WhiteLabelType==2){
              this.content=result.Content;
              this.image=true;
              this.paygimage=false;
              this.resellername=true;
              this.paygname=false;
              this.hidebutton=false;
              localStorage.setItem("WhitelabelContent", this.content);
             

          }
          else{
              this.image=false;
          this.paygimage=true;
          this.resellername=false;
          this.paygname=true;
          this.hidebutton=true;
          }
          }
          else{
              this.image=false;
              this.paygimage=true;
              this.resellername=false;
              this.paygname=true;
              this.hidebutton=true;
          }
      });
      }
   
    });

  }
 

  login() {
    this.getBrowserName();
    let form = { username: "", password: "" ,IpAddress:"",ResellerUrl:"",DeviceType:"",GeoLocation:"",AppVersion:"",DeviceId:""};
    form.username = this.email.value;
    form.password = this.password.value;
    // form.IpAddress=this.CurrentIp;
    form.ResellerUrl=this.resellerUrl;
    form.DeviceType=this.devicetype;
    var deviceData=JSON.stringify(this.deviceInfo);
    form.DeviceId =deviceData;  
    form.GeoLocation=this.GeoLocation;
    form.AppVersion="Vpos"
    let encodedcredentials = btoa(this.email.value + ':Internal');
    this.isloginSuccess = this.service.loginUser(form).subscribe(res => {

      if (environment.clientsidelogflag == 0) {
        console.log("login service - promise response data:  ", res);
      }
      if (res['Code'] == "0401") {
         
        this.checkvposlogin();
       
      }
      else if(res['Code'] == "402")
      {
        this.AccountBlocked = false;
        this.isloginfailed = false;
        this.ipaddressrequired = true;
        this.isIpAddressVerified=false;
        
      }
     else if(res['Code'] == "5003")
      {
        this.AccountBlocked = true;
        this.isloginfailed = false;
        this.ipaddressrequired = false;
        this.isIpAddressVerified=false;
        
      }
      else if(res['Code'] == "5004")
      {
        this.AccountBlocked = false;
        this.isloginfailed = false;
        this.isIpAddressVerified=true;
        this.ipAddressValidationMsg=res['DeveloperMessage']
      }
      else {
        localStorage.setItem("VirtualPOSToken", JSON.stringify(res));
    


      }

      let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();

      let dateString = merchantdata.PasswordExpiryDate;
      var datearray = dateString.split("-");
      var newdate = datearray[1] + '-' + datearray[0] + '-' + datearray[2];
      let passwordExpiryDate = new Date(dateString);
      let currentdate = new Date();
      let usertype=merchantdata.UserType;
      let ContactNo=merchantdata.ConfirmedMobile;
       let AccountLockDate=merchantdata.AccountLockDate;
  if ((merchantdata.ConfirmedMobile=="false" || merchantdata.ConfirmedMobile=="False" ||merchantdata.IsDefaultPassword==1) &&(merchantdata.ConfirmedEmail=="false" || merchantdata.ConfirmedEmail=="False" ||merchantdata.IsDefaultPassword==1))
   { 
          if(isNumeric(this.email.value))
          {
           if(this.router.url.includes('us/en'))
           {
            this.router.navigate(['/us/en/registration/OtpVerfication',
            {phone:this.email.value,email:'',type:usertype}]);
           }
           else if(this.router.url.includes('in/te'))
           {
            this.router.navigate(['/in/te/registration/OtpVerfication',
            {phone:this.email.value,email:'',type:usertype}]);
           }
           else if(this.router.url.includes('in/en'))
           {
            this.router.navigate(['/in/en/registration/OtpVerfication',
            {phone:this.email.value,email:'',type:usertype}]);
           }
           else if(this.router.url.includes('in/hi'))
           {
            this.router.navigate(['/in/hi/registration/OtpVerfication',
            {phone:this.email.value,email:'',type:usertype}]);
           }
           else
           {
            this.router.navigate(['/registration/OtpVerfication',
            {phone:this.email.value,email:'',type:usertype}]);
           }
          }
          else
          {
            if(this.router.url.includes('us/en'))
            {
              this.router.navigate(['/us/en/registration/OtpVerfication',
              {phone:'',email:this.email.value,type:usertype}]);
            }
            else if(this.router.url.includes('in/te'))
            {
              this.router.navigate(['/in/te/registration/OtpVerfication',
              {phone:'',email:this.email.value,type:usertype}]);
            }
            else if(this.router.url.includes('in/en'))
            {
              this.router.navigate(['/in/en/registration/OtpVerfication',
              {phone:'',email:this.email.value,type:usertype}]);
            }
            else if(this.router.url.includes('in/hi'))
            {
              this.router.navigate(['/in/hi/registration/OtpVerfication',
              {phone:'',email:this.email.value,type:usertype}]);
            }
           else
           {
            this.router.navigate(['/registration/OtpVerfication',
            {phone:'',email:this.email.value,type:usertype}]);
           }
          }
    } 

      else
      {
       if (res == null) 
       {
        this.isloginfailed = true;
        this.isEmailConfirmationPending =false;
       }
      else if (passwordExpiryDate < currentdate) 
      {
        this.isPasswordExpired = true;
        if(isNumeric(this.email.value))
        {

          {
            swal({
    
              title: 'PasswordExpired',
              icon: 'warning',
              buttons: {
                confirm: {
                  text: 'ok',
                  value: true,
                  visible: true,
                  className: "bg-primary",
                  closeModal: true
                }
              }
    
            }).then((isConfirm) => {
              if (isConfirm) {
                // window.location.reload();
                this.service.resendMobileOTP(this.email.value,"Merchant").subscribe(res => {
                  if(res!=null){
                    swal("Update", "OTP Sent Successfully", "success");
                   
                  }
                });
                if(this.router.url.includes('us/en'))
                {
                 this.router.navigate(['us/en/registration/OtpVerfication',
                 {phone:this.email.value,email:'',type:usertype}]);
                }
                else  if(this.router.url.includes('in/te'))
                {
                 this.router.navigate(['in/te/registration/OtpVerfication',
                 {phone:this.email.value,email:'',type:usertype}]);
                }
                else  if(this.router.url.includes('in/en'))
                {
                 this.router.navigate(['in/en/registration/OtpVerfication',
                 {phone:this.email.value,email:'',type:usertype}]);
                }
                else  if(this.router.url.includes('in/hi'))
                {
                 this.router.navigate(['in/hi/registration/OtpVerfication',
                 {phone:this.email.value,email:'',type:usertype}]);
                }
                else{
                 this.router.navigate(['/registration/OtpVerfication',
                 {phone:this.email.value,email:'',type:usertype}]);
                }
              } else {
                // swal('Cancelled', 'Your imaginary file is safe :)', 'error');
              }
            });
           
  
          }

        }
        else{
          {
            swal({
    
              title: 'PasswordExpired',
              icon: 'warning',
              buttons: {
                confirm: {
                  text: 'ok',
                  value: true,
                  visible: true,
                  className: "bg-primary",
                  closeModal: true
                }
              }
    
            }).then((isConfirm) => {
              if (isConfirm) {
                // window.location.reload();
                this.service.resendEmailOTP(this.email.value,"Merchant").subscribe(res => {
                  if(res!=null){
                    swal("OTP", "OTP Sent Successfully", "success");
                    
                  }
                });
                if(this.router.url.includes('us/en'))
                {
                 this.router.navigate(['/us/en/registration/OtpVerfication',
                 {phone:'',email:this.email.value,type:usertype}]);
                }
                else if(this.router.url.includes('in/te'))
                {
                 this.router.navigate(['/in/te/registration/OtpVerfication',
                 {phone:'',email:this.email.value,type:usertype}]);
                }
                else if(this.router.url.includes('in/en'))
                {
                 this.router.navigate(['/in/en/registration/OtpVerfication',
                 {phone:'',email:this.email.value,type:usertype}]);
                }
                else if(this.router.url.includes('in/hi'))
                {
                 this.router.navigate(['/in/hi/registration/OtpVerfication',
                 {phone:'',email:this.email.value,type:usertype}]);
                }
                else{
                 this.router.navigate(['/registration/OtpVerfication',
                 {phone:'',email:this.email.value,type:usertype}]);
                }
    
      
              } else {
                // swal('Cancelled', 'Your imaginary file is safe :)', 'error');
              }
            });
            
          }
        }

        // this.router.navigate(["registration/OtpVerfication"], {
        //   queryParams: { email: encodedcredentials }
        // });
      }
      else if (merchantdata.UserType == "MerchantUser") {
        this.AccountLockDate =AccountLockDate
        this.MerchantStatus();
     

      }
      else {


        let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.registerUserService.Resellerinfoes(merchantdata.MerchantKeyId).subscribe(data => {
      localStorage.removeItem('logodetails');
      localStorage.removeItem('logoimagepath');
     
      if(data.Logo == "NULL"|| data.Logo ==''|| data.Logo==undefined)
      {
        let logo="0";             
         localStorage.setItem('logodetails', logo);     
        }
        else{
          
        let imageurl=data.Logo;
        
        if(imageurl!="NULL"){
      
          let logo="1";
          localStorage.setItem('logodetails', logo);
          let resellerlogo= this.imagepath+imageurl;
        localStorage.setItem('logoimagepath', resellerlogo);    
        }
        
      }
     
    });
        let resellerno = this.commonfunction.getUserMerchantData().ResellerId;
        this.registerUserService.isValidMerchantKeyId(merchantdata.MerchantKeyId, resellerno).subscribe(result => {
          if (environment.clientsidelogflag == 0) {
            console.log("Merchant info result - ", result);
          }
          if ((result.MerchantKeyId > 0 && result.Status <= 5)|| result.Status == 7) {
            let LockDate =AccountLockDate
            var datePipe = new DatePipe("en-US");
            var date=new Date();
            var currentlocaldatetime = datePipe.transform(date, 'dd/MM/yyyy');
            // if(LockDate >= currentlocaldatetime)
            // {
            //  this.AccountBlocked=true;
            //  this.isloginfailed=false;
            // }

            // else{
              this.AccountBlocked=false;
              this.isValidMerchant = true;
              this.isMerchantNotActive = false;
              this.isAccountOnHold = false;
              this.isAccountCancled = false;
              this.isAccountDeclined = false;
              this.isEmailConfirmationPending =false;
              if (environment.clientsidelogflag == 0) {
                console.log("login service - promise response data:  ", res);
              }
                  this.UserPreferenceSettings();


              this.router.navigate(["/home"]);
            let permissions = this.commonfunction.getRolesPermissions();
            if (environment.clientsidelogflag == 0) {
              console.log("permissions:  ", permissions);
            }
          }
          else if (result.Status == 9) {
            this.isAccountOnHold = true;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isloginfailed = false;
            this.isEmailConfirmationPending =false;
          }
          else if (result.Status == 10) {
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = true;
            this.isloginfailed = false;
            this.isEmailConfirmationPending =false;
          }
          else if (result.Status == 11) {
            this.isAccountOnHold = false;
            this.isAccountCancled = true;
            this.isAccountDeclined = false;
            this.isloginfailed = false;
            this.isEmailConfirmationPending =false;
          }
          else if (result.Status == 6) {
            this.isValidMerchant = true;
            this.isMerchantNotActive = true;
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isEmailConfirmationPending =false;
          }
          // else if (result.Status == 21) {
          //   this.router.navigate(["/home/welcomepayg"]);
          
          // }

         // else if (result.Status >= 12 || result.Status <= 20 || result.Status == 0 || result.Status == 1) {
          else if (result.Status >= 12 || result.Status <= 22) {
          
            this.router.navigate(['/registration/InprogressPage', { merchantKeyId: result.MerchantKeyId, status: result.Status }]);
          }
          else if (result.MerchantKeyId > 0 && (result.Status >= 5 || result.Status <=8)) {
            this.isValidMerchant = true;
            this.isMerchantNotActive = true;
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isEmailConfirmationPending =false;
          }
          else {
            this.isValidMerchant = false;
            this.isMerchantNotActive = false;
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isEmailConfirmationPending =false;
          }
        });
      }
     }
    });
  }


  checkvposlogin(){
    this.service.GetUserDetails(this.email.value,"Merchant").subscribe(res =>{
      if(res !=null){
        this.usernameerror=false;
        this.isloginfailed=false;
        if(res.ResponseText=="Your Account Is Blocked")
        {
          this.AccountBlocked=true;
        }
        else
        {
          this.AccountBlocked=false;

          this.nooftimes = res.NoofFailureAttempt;



          this.nooftimes=this.nooftimes+1;
          this.times=4-this.nooftimes;
          this.nooftimeserrormessage=true;
          
          this.isloginfailed = true;
          this.AccountBlocked = false;
          this.ipaddressrequired = false;
          this.isIpAddressVerified=false;
          
          if(this.times==0)
        {
          this.AccountBlocked = true;
          this.nooftimeserrormessage=false;
        }
        if(this.nooftimes>=4)
        {
          //this.AccountBlocked = true;
          //alert(this.nooftimes)
          this.nooftimeserrormessage=false;
        }
        if(this.nooftimes<4)
          {
          swal("Caution", "You have only "+  this.times +" attempts left to enter correct password" , "warning");
          }
          if(this.nooftimes==3)
          {
          swal("Caution", "You have only "+  this.times +" attempt left to enter correct password" , "warning");
          }
          }


         if (isNumeric(this.email.value))
          if(res.ContactNo != null){
            if(res.MobileNoConfirmed == false){
              this.service.resendMobileOTP(res.ContactNo,2).subscribe(res => {
                if(res!=null){
               if(this.router.url.includes('us/en'))
               {
                this.router.navigate(['/us/en/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
              else if(this.router.url.includes('in/te'))
               {
                this.router.navigate(['/in/te/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
              else if(this.router.url.includes('in/en'))
               {
                this.router.navigate(['in/en/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
              else if(this.router.url.includes('in/hi'))
               {
                this.router.navigate(['/in/hi/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
               else{
                this.router.navigate(['/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
                }
              });
              
            }
          }
          if (!isNumeric(this.email.value))
          {
          if(res.ConfirmedEmail == false){
            if(res.Email != null){
            this.service.resendEmailOTP(res.Email,2).subscribe(res => {
              if(res!=null){
               if(this.router.url.includes('us/en'))
               {
                this.router.navigate(['/us/en/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
               else  if(this.router.url.includes('in/te'))
               {
                this.router.navigate(['/in/te/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
               else  if(this.router.url.includes('in/en'))
               {
                this.router.navigate(['/in/en/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
               else  if(this.router.url.includes('in/hi'))
               {
                this.router.navigate(['/in/hi/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
              
               else{
                this.router.navigate(['/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
              }
            });
            
          }
        }
        }

              
      }
      else
      {
        // this.usernameerror=true;
         this.isloginfailed=true;
      }
    });
  }


  
  UserPreferenceSettings()
  {   
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.registerUserService.GetUserPreferenceSettings(merchantdata.MerchantKeyId,merchantdata.UserId).subscribe(result => {
      if(result !=null)
      {
       localStorage.setItem("SettingDetails",JSON.stringify(result));
      }
      else{
          let form = {
  
         MerchantKeyId: 0,
         UserName:"",   
         UserId:"", 
  
       };
       this.username = this.commonfunction.getUserName();
         this.registerUserService.UserPreferenceSettings(merchantdata.MerchantKeyId,merchantdata.UserId,merchantdata.UserId).subscribe(result => {
           if(result !=null)
           {
                 
           }
       
         });
  
      }
  
  
       })
  }
  
  

  isformvalid() {
    return (this.email.invalid && (this.email.dirty || this.email.touched)) || (this.password.invalid && (this.password.dirty || this.password.touched))
  }


  emailerrors() {
    return this.email.hasError("required") ? "Email/Text  is required " : "";
    // return this.email.hasError("required")
    //   ? "Email/Mobile is required": "";
      // : this.email.hasError("email") ? "Enter valid Email Address" : "";
  }

  passworderrors() {
    return this.password.hasError("required") ? "Password is required " : "";
  }


  transform(value: string) {
    var datePipe = new DatePipe("en-US");
    var date=new Date();
    var values = datePipe.transform(date, 'dd/MM/yyyy');
     this.lockdates=values;
     return value;
 }
   MerchantStatus()
   {
     
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    let resellerno = this.commonfunction.getUserMerchantData().ResellerId;
    this.registerUserService.isValidMerchantKeyId(merchantdata.MerchantKeyId, resellerno).subscribe(result => {
      if(result != null)
      {
        this.Merchantstatus=result.Status;
        this.UserPreferenceSettings();

        if (merchantdata.Status == 'Approved') {

        //  this.AccountLockDate =AccountLockDate
            var datePipe = new DatePipe("en-US");
            var date=new Date();
            var currentlocaldatetime = datePipe.transform(date, 'dd/MM/yyyy');
            // if(LockDate >= currentlocaldatetime)
            // {
            //  this.AccountBlocked=true;
            //  this.isloginfailed=false;
            // }
            
            // else{
              this.isAccountVerificationPending = false;
              this.isEmailConfirmationPending =false;
              this.isAccountApproved = true;
              this.isAccountRejected = false;
              this.UserPreferenceSettings();
              if(this.Merchantstatus==6)
              {
                  this.isMerchantNotActive=true;
              }
              else{
                this.router.navigate(["/home"]);
                this.isMerchantNotActive=false;
              }
             
             }
            
          // }
          else if (merchantdata.Status == 'Rejected') {
            this.isAccountApproved = false;
            this.isAccountRejected = true;
            this.isAccountVerificationPending = false;
            this.isEmailConfirmationPending =false;
          }
          else if (merchantdata.Status == 'VerificationPending' ||merchantdata.Status == 'Active' ) {
            this.isAccountApproved = false;
            this.isAccountRejected = false;
            this.isAccountVerificationPending = true;
            this.isEmailConfirmationPending =false;
          }
          else {
            this.isAccountApproved = false;
            this.isAccountRejected = false;
            this.isAccountVerificationPending = false;
            this.isEmailConfirmationPending =false;
          }
      }
    });
   }


   public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        this.devicetype="edge";
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        this.devicetype="opera";
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        this.devicetype="chrome";
        return 'chrome';
      case agent.indexOf('trident') > -1:
        this.devicetype="ie";
        return 'ie';
      case agent.indexOf('firefox') > -1:
        this.devicetype="firefox";
        return 'firefox';
      case agent.indexOf('safari') > -1:
        this.devicetype="safari";
        return 'safari';
      default:
        this.devicetype="other";
        return 'other';
    }
}



  
getUserLocation(){
  navigator.geolocation.getCurrentPosition((position)=>{
    this.IsLocationAllow=true;
    this.GeoLocation="latitude:"+position.coords.latitude+",longitude:"+position.coords.longitude;
  },
  (error) => {
    this.IsLocationAllow = false;
    let errorMessage = '';
    if (error.PERMISSION_DENIED) {
      errorMessage = `Couldn't get your location Permission denied. \n Please allow the location for access.`;
      swal("Error", errorMessage.toString(), "error");
    } 
    else if (error.POSITION_UNAVAILABLE) {
      errorMessage = `Couldn't get your location Position unavailable. \n Please allow the location for access.`;
      swal("Error", errorMessage.toString(), "error");
    } 
    else if (error.TIMEOUT) {
      errorMessage = `Couldn't get your location'+'Timed out.`;
      swal("Error", errorMessage.toString(), "Time Out");
    } 
    else {
      swal(error.message+ `Error: ${error.code}`);
    }
  },{ enableHighAccuracy: true }
  );
}


checkUserNameverfication()
{
  this.usernameerror=false;
  this.service.GetUserDetails(this.email.value,"Merchant").subscribe(res =>{
    if(res !=null){


      this.isloginfailed=false;

      if(res.ResponseText=="Your Account Is Blocked")
        {
          this.AccountBlocked=true;
        }
        else if(res.ResponseText=="You will receive an email/sms otp to retrieve your password if the email address/mobile number is registered with us.")
        {

          this.isloginfailed=true;
        }
        else
        {
          if (isNumeric(this.email.value))
          if(res.ContactNo != null){
            if(res.MobileNoConfirmed == false){
              this.service.resendMobileOTP(res.ContactNo,2).subscribe(result => {
                if(result!=null){
               if(this.router.url.includes('us/en'))
               {
                this.router.navigate(['/us/en/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
              else if(this.router.url.includes('in/te'))
               {
                this.router.navigate(['/in/te/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
              else if(this.router.url.includes('in/en'))
               {
                this.router.navigate(['in/en/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
              else if(this.router.url.includes('in/hi'))
               {
                this.router.navigate(['/in/hi/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
               else{
                this.router.navigate(['/registration/OtpVerfication',{phone:res.ContactNo,email:'',type:'Merchant'}]);
               }
                }
              });
              
            }
            else
            {
              this.login();
            }
          }
          
          if (!isNumeric(this.email.value))
          {
            if(res.Email != null){
          if(res.ConfirmedEmail == false){
            this.service.resendEmailOTP(res.Email,2).subscribe(result => {
              if(result!=null){
               if(this.router.url.includes('us/en'))
               {
                this.router.navigate(['/us/en/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
               else  if(this.router.url.includes('in/te'))
               {
                this.router.navigate(['/in/te/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
               else  if(this.router.url.includes('in/en'))
               {
                this.router.navigate(['/in/en/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
               else  if(this.router.url.includes('in/hi'))
               {
                this.router.navigate(['/in/hi/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
              
               else{
                this.router.navigate(['/registration/OtpVerfication',{phone:'',email:res.Email,type:'Merchant'}]);
               }
              }
            });
            
          }
          else
          {
            this.login();
          }
        }
          
        }
  
        }
     
            
    }
    else
    {
      this.isloginfailed=true;
    }
  });
}
epicFunction() { 
  this.deviceInfo = this.deviceService.getDeviceInfo();
 }
 
showHidePassword()
{
  this.showPassword = !this.showPassword;
if(this.showPassword==true)
{
  this.isView = true;
  this.isNoView = false;
}
else{
  this.isView = false;
  this.isNoView = true;
}
  
//   this.showPassword = !this.showPassword;
//   this.isView = true;
//  this.isNoView = false;
//  setTimeout(()=>{                           //<<<---using ()=> syntax
//   this.showPassword = false;
//   this.isView = false;
//  this.isNoView = true;
//   },10000);

// this.showPassword = !this.showPassword;
 //this.isView = false;
//  setTimeout(()=>
//  {                           //<<<---using ()=> syntax
//    this.showPassword = 
//    true;
   
//  }, 10000);
}
}
